import { useState } from 'react';
import { isMobileOrTabletDevice } from '../../../utils/deviceUtils';

export function useIsMobileOrTabletDevice() {
    const [isMobileOrTablet] = useState(isMobileOrTabletDevice);
    return isMobileOrTablet;
}
